import * as h2Api from '../../h2Api'

export const LOADER_REQUEST = 'LOADER_REQUEST'

export const loadWages = data => dispatch => {
  const { file, ...formFields } = data
  const formData = new FormData()

  if (file) {
    console.log(file)
    Array.from(file).forEach(f => formData.append('file', f))
  }

  //formData.fi
  const json = JSON.stringify(formFields)

  formData.append('json', json)
  //console.log(planId, taskId, data, formData, json)

  return dispatch(
    h2Api.postFile(`/admin/maintenance/loader/wages`, formData)({ type: LOADER_REQUEST })
  )
}

export const loadProjections = data => dispatch => {
  const { file, ...formFields } = data
  const formData = new FormData()

  if (file) {
    console.log(file)
    Array.from(file).forEach(f => formData.append('file', f))
  }

  //formData.fi
  const json = JSON.stringify(formFields)

  formData.append('json', json)
  //console.log(planId, taskId, data, formData, json)

  return dispatch(
    h2Api.postFile(
      `/admin/maintenance/loader/outlook`,
      formData
    )({ type: LOADER_REQUEST })
  )
}
